import '././css/main.css'
import GiveUsACallModal from './Components/GiveUsACallModal.jsx'
import {useRtlProps} from './helpers/rtl.js'

function AppGiveUsACallModal() {
  const rtl = useRtlProps()
  return (
    <div id="translated-app" {...rtl}>
      <GiveUsACallModal />
    </div>
  )
}

export default AppGiveUsACallModal
